export default __webpack_public_path__ + "static/media/EI4-2.0e72cd76.jpg";